import React, { useEffect, useState } from "react";
import {
  TextField,
  Button,
  FormControl,
  Container,
  Grid,
  Box,
  Stack,
  OutlinedInput,
  InputLabel,
  MenuItem,
  ListItemText,
  Select,
  Checkbox,
  Radio,
  RadioGroup,
  FormControlLabel,
  FormLabel,
  Modal,
  Typography,
  Divider,
} from "@mui/material";
// import "./test.css";
import SearchIcon from "@mui/icons-material/Search";

import dayjs from "dayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { TimePicker } from "@mui/x-date-pickers/TimePicker";
// import { bookApoinment } from "./asppoinmentApi";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router";
import { routePath } from "../../constants/routePath";
import { setSession } from "../../utils/commonUtils";
import { setCustomerAppointmentId } from "../../app/store/reducer";
// import dayjs from 'dayjs';
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import { getAlldetailSerice } from "../services/servicesListApi";
import EmployeeModal from "../../common/employeeModel";
import {
  addMessageCount,
  addOffer,
  bulImageUpload,
  bulkMessage,
  bulkMessageApload,
} from "./apiFunction";
import ImageUploadButton from "../../common/imgUpload";
import SearchModalCustomer from "../../common/searchModal/customer";
import { ModalHeader } from "../../common/modalHeader";
import { useRef } from "react";
dayjs.extend(utc);
dayjs.extend(timezone);

const PopUpWp = ({
  open,
  setOpen,
  data,
  feature,
  countCredit,
  callbackGetMsg,
}) => {
  const fileInputRef = useRef(null);

  // State to store the uploaded image URL
  const [displayErr, setDisplayErr] = useState({ status: false, Msg: "" });
  const [imageSrc, setImageSrc] = useState(null);
  const [filet, setFilet] = useState(null);
  const [count, setCount] = useState(0);

  const [openT, setOpenT] = useState(false);
  const [selectedData, setSeletecData] = useState(null);
  const struct = {
    billerId: "",
    customerName: "",
    mobileNumber: "",
    // otp: "",
    mailId: "",
    gender: "",
    service: "",
    date: "",
    hour: "",
    minute: "",
    status: "Unassigned",
    employeeId: "",
  };

  const [selectedValue, setSelectedValue] = useState([]);
  useEffect(() => {
    let dd = "";
    console.log("selectedValueselectedValue ", selectedValue);
    selectedValue.forEach((ele, index) => {
      dd += ele.name + ",";
    });
    setSeletecData({ name: dd });
  }, [selectedValue]);
  const [formData, setFormData] = useState({ ...struct });
// const sendAllMessages = async () => {
//   for (const ele of selectedValue) {
//     try {
//       await bulkMessageApload(
//         {
//           "app-key": "...",
//           "auth-key": "...",
//           template_id: "2069008486859119",
//           device_id: "6738338037d156722c02c587",
//           media: filet || "",
//           destination_number: ele.customerMobile || "",
//           variables: [formData.customerName || ""],
//         },
//         (res) => {
//           console.log("Sent to", ele.customerMobile, "status:", res.data);
//         }
//       );
//     } catch (err) {
//       console.error("Error sending to", ele.customerMobile, err);
//       // Optionally break or continue to next
//     }
//   }
//   setOpen(false);
// };

// // Call this in `handle` instead of forEach
// sendAllMessages();



  const handle = (e) => {
    e.preventDefault();
    // addOffer({message:formData.customerName},(data)=>{
    //     alert('ioni')
    // })
    // const whatsappLink = `https://web.whatsapp.com/send?phone=${selectedData?.customerMobile}&text=${formData?.customerName}`;
    // window.open(whatsappLink, "_blank");
    addMessageCount(
      {
        count: selectedValue.length * -1,
      },
      (data) => {
        // console.log()
        // setCount()
        // setSelectedValue([])
        callbackGetMsg();
      }
    );
    selectedValue.forEach(async (ele, index) => {
      bulkMessageApload(
        {
          "app-key": "68b71452-6c72-4e16-92fa-f78d7328df3c",
          "auth-key": "9d9bced6b415ff1e3b7ab141c8c02bce19a5091e89505992c7",

          template_id: "2069008486859119",
          device_id: "6738338037d156722c02c587",
          media: filet ? filet : "",
          destination_number: ele.customerMobile ? ele.customerMobile : "",

          message: formData.customerName ? formData.customerName : "",
          // variables: [
          //   formData.customerName || "",
          //   // Add more variables if your template uses {{2}}, {{3}}, etc.
          //   // Example: "Discount offer", "Valid till Oct 31"
          // ],
        },
        (res) => {
          setOpen(false);
          console.log("resreswhatapp", res?.data?.status);
        }
      );
    });


//     selectedValue.forEach((ele, index) => {
//   bulkMessageApload(
//     {
//       "app-key": "68b71452-6c72-4e16-92fa-f78d7328df3c",
//       "auth-key": "9d9bced6b415ff1e3b7ab141c8c02bce19a5091e89505992c7",
//       template_id: "2069008486859119",
//       device_id: "6738338037d156722c02c587",
//       destination_number: ele.customerMobile || "",
//       media: filet || "",
//       variables: [
//         formData.customerName || "",
//         "OptionalOfferMessage",
//         "OptionalUserInfo",
//       ],
//     },
//     (res) => {
//       console.log("Message response:", res.data);
//       if (index === selectedValue.length - 1) setOpen(false); // close modal after last message
//     }
//   );
// });

    // selectedValue.forEach((ele, index) => {
    //   const phone = ele.customerMobile;
    //   let message = formData.customerName || "";

    //   // Append image URL if exists
    //   if (imageSrc) {
    //     message += `\n\nImage: ${imageSrc}`;
    //   }

    //   const encodedMessage = encodeURIComponent(message);
    //   const whatsappLink = `https://web.whatsapp.com/send?phone=${phone}&text=${encodedMessage}`;

    //   // Open the WhatsApp message in a new tab
    //    setTimeout(() => {
    //      window.open(whatsappLink, "_blank");
    //    }, index * 1000);
    // });
  };
  useEffect(() => {
    if (open == true) {
      console.log("Data", data);

      if (data) {
        setFormData({ ...formData, customerName: data?.message });
      } else {
      }
    } else {
      setSelectedValue([]);
      setFormData(struct);
      setImageSrc(null);

      setFilet(null);
    }
  }, [open]);
  const [search, setSearch] = useState("");
  return (
    <Modal
      open={open}
      onClose={() => {
        setOpen(false);
      }}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box
        sx={{
          background: "white",
          width: { xs: "95%", sm: "40%", md: "40%", lg: "40%", xl: "40%" },

          borderRadius: "10px",
          position: "absolute",
          left: { xs: "2%", sm: "25%", md: "35%", lg: "35%", xl: "30%" },

          top: "10%",
        }}
      >
        <ModalHeader
          title={"Bulk Message"}
          onClose={(data) => {
            setOpen(data);
          }}
        />
        <Container
          sx={{
            padding: "10px 8px !important",
          }}
        >
          <Box
            sx={{
              overflowY: "auto",
              height: "54vh",
              paddingX: "10px",
            }}
          >
            <form onSubmit={handle}>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={12}>
                  <Box
                    // disabled
                    // size="small"
                    readonly
                    fullWidth
                    onClick={() => {
                      // setSearchOutStandingsModal(true)
                    }}
                    // id="name"
                    // label="Search by Name/Mobile Number"
                    // value={search}
                    sx={{
                      display: "flex",
                      height: "23px",
                      justifyContent: "space-between",
                      // width: "70%",
                      border: "1px solid #c9c9c9",
                      p: 1,
                      borderRadius: "4px ",
                      color: "grey",
                      "&:hover": {
                        cursor: "pointer !important",
                      },
                    }}
                    onChange={(e) => {
                      // setSearch(e.target.value);
                    }}
                  >
                    <Typography variant="p">
                      {/* {selectedData?.name !== "" ? search : "Search by Name/Mobile Number"} */}

                      {selectedData?.name !== ""
                        ? selectedData?.name
                        : "Search :"}
                    </Typography>
                    <SearchIcon
                      onClick={() => {
                        // setSearchModal(true)
                        setOpenT(true);
                      }}
                      sx={{
                        color: (theme) => theme.palette.primary.main,
                        cursor: "pointer",
                      }}
                    />
                  </Box>
                </Grid>
                <Grid item xs={12} sm={12}>
                  <FormControl fullWidth>
                    <TextField
                      label="Enter Message"
                      name="customerName"
                      value={formData.customerName}
                      onChange={(e) => {
                        setFormData({
                          ...formData,
                          customerName: e.target.value,
                        });
                      }}
                      required
                      multiline // Makes the TextField act as a textarea
                      rows={8} // Number of rows (you can adjust this)
                      InputLabelProps={{ className: "mulish" }}
                      InputProps={{ classes: { input: "mulish" } }}
                    />
                  </FormControl>
                </Grid>

                <Grid item xs={12}>
                  <ImageUploadButton
                    imageSrc={imageSrc}
                    setImageSrc={(data) => {
                      setImageSrc(data);
                      setFilet(data);
                    }}
                    // fileCb={(file) => {
                    //   const formData = new FormData();
                    //   formData.append("File", file); // Name should match the expected key on the server-side

                    //   bulImageUpload(formData, (res) => {
                    //     console.log("ttytyt ", res?.data?.data?.imageBillPath);
                    //     setFilet(res?.data?.data?.imageBillPath);
                    //   });
                    // }}
                    fileInputRef={fileInputRef}
                    useCloudinary={false}
                  />
                </Grid>
                <Grid item xs={12}>
                  <Divider
                    sx={{
                      backgroundColor: "#4E4E4E",
                      height: "0.5px",
                      marginX: "-10px",
                    }}
                  />
                </Grid>

                <Grid item xs={12} sx={{ paddingX: "40px !important" }}>
                  <Button
                    type="submit"
                    variant="contained"
                    fullWidth
                    sx={{
                      backgroundColor: "#01008B",
                      fontSize: "18px",
                    }}
                  >
                    Send Message
                  </Button>
                </Grid>
              </Grid>
            </form>
          </Box>
        </Container>

        <SearchModalCustomer
          displayErr={displayErr}
          setDisplayErr={setDisplayErr}
          countCredit={countCredit}
          feature={feature}
          searchModal={openT}
          selectedValue={selectedValue}
          setSelectedValue={setSelectedValue}
          setSearchModal={setOpenT}
          callback={(data) => {
            setSeletecData(data);
            setOpenT(false);
          }}
        />
      </Box>
    </Modal>
  );
};

export default PopUpWp;
